import { Injectable } from '@angular/core'
import { ReplaySubject } from 'rxjs'

export interface LogData {
  ts: Date
  level: string
  message: string
}

@Injectable({
  providedIn: 'root',
})
export class LogService {
  debugMode = false
  logs$: ReplaySubject<LogData> = new ReplaySubject(1000)

  constructor() {
    // do nothing
  }

  public init(debugMode: boolean): void {
    this.info(`[LogService] Init (debugMode=${debugMode})`)
    this.debugMode = debugMode
  }

  private _log(level: string, message: string): void {
    const data: LogData = {
      ts: new Date(),
      level: level,
      message: message,
    }
    console.log(`[${data.level.toUpperCase()}] ${data.message}`)
    this.logs$.next(data)
  }

  public debug(message: string): void {
    if (this.debugMode) {
      this._log('debug', message)
    }
  }

  public log(message: string): void {
    this._log('info', message)
  }

  public info(message: string): void {
    this._log('info', message)
  }

  public error(message: string): void {
    this._log('error', message)
  }
}
